import React from "react";
import "./footer.scss";

export default function Footer(){
  return(
    <div className="footer" id="footer">
    <div className="footer-header">Our Offices</div>
      <div className="footer-row">
      <div className="sect"><p className="sect-head">Delhi</p>Leverage Edu Tower,<br/>A-258, Bhishma Pitamha Marg, Block A,Defence Colony, New Delhi, Delhi 110024</div>
      <div className="sect"><p className="sect-head">Bangalore</p>Leverage Edu BHIVE <br/>Workplace MG Road, Mahalaxmi Chambers ,29, MG Road Next to Trinity Metro Station, Opp. Kotak Bank, Bengaluru, Karnataka 560001</div>
      <div className="sect"><p className="sect-head">Mumbai </p>91 Springboard, Lotus Building, Plot No. D-5 Road No. 20, Maroli MIDC, Andheri East, Mumbai Maharashtra 400069</div>
      <div className="sect"><p className="sect-head">Hyderabad</p>2nd floor, SpringBoard Coworking space, Mytri Square, 2-41/11, 6/2, Gachibowli - Miyapur Rd, Opp.Sharath Capital, Prashanth Nagar Colony, Hyderabad, Telangana 500084</div>
      <div className="sect"><p className="sect-head">Toronto</p>628 Fleet Street, Toronto, MSV 1A8 Ontario, Canada</div>
       <div className="sect"><p className="sect-head">London</p>126 Westminster Square, London, SE1 7UN, UK</div>
       <div className="sect"><p className="sect-head"></p></div>
        <div className="sect"><p className="sect-head"></p></div>

      </div>
    </div>
  )
}
